import React from 'react';

import boTheme from '@ecp/common/src/style/theme/bo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox, textBoxProps } from '@ecp/common/src/text/TextBox';
import { ReactComponent as InfoIcon } from '@ecp/common/src/assets/icon/icon__tooltip-info.svg';

const InfoTextBox = React.forwardRef((props, ref) => (
  <FlexBox align-items={'normal'}>
    <InfoIcon width={'18px'} height={'18px'} />
    <Spacing right={'6px'} />
    <TextBox {...props} ref={ref}></TextBox>
  </FlexBox>
));

InfoTextBox.displayName = 'TextBox';

InfoTextBox.propTypes = {
  ...textBoxProps,
};

InfoTextBox.defaultProps = {
  size: '13px',
  weight: 400,
  color: boTheme.color.sub1,
};

export default InfoTextBox;
